module.exports = __webpack_public_path__ + "img/program-list.2e385c93.svg";